import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_AUTH_TOKENS_REMOVE_DIGIPAS: MijnRoute = {
    path: 'digipas-verwijderen/:id',
    navigationEvent: 'toDigipasVerwijderen',
    regex: /^\/zelf-regelen\/inlogmiddelen-beheren\/digipas-verwijderen\/[^/]+$/,
    webcomponent: 'mijn-tokens-beheer-webcomponent',
    internalPath: '/digipas-verwijderen/:id'
};
